export const API_URL_BLOG = "/blog";
